import { language } from "@chef/constants";

export const intl = (
  {
    no: {
      SUGGESTIONS_TO_IMPROVE:
        "Har du andre forslag til hva vi kan gjøre bedre?",
      SUGGESTIONS_TO_IMPROVE_DESCRIPTION: "Vi vil gjerne høre fra deg!",
      OPTIONAL: "Frivillig",
      GO_FORWARD: "Gå videre",
      CANCEL: "Avbryt",
      PAUSE_SUBSCRIPTION: "Pause abonnement",
      ADD_COMMENT: "Legg til en kommentar",
      SUBSCRIPTION_IS_PAUSED: "Abonnement afmeldt.",
      CAN_NOT_CHANGE_SUBSCRIPTION_STATUS: "Kunne ikke endre abonnement status.",

      CHOOSE_ONE_OF_THE_OPTIONS_BELOW: "Velg et av alternativene nedenfor.",
      WHERE_WILL_YOU_BUY_FOOD_IN_THE_FUTURE: "Hvor vil du handle mat fremover?",
      ANOTHER_ONLINE_GROCERY_STORE: "Annen matbutikk online",
      ANOTHER_ONLINE_MEALBOX_SERVICE: "Annen matkassetjeneste online",
      PHYSICAL_STORE: "Fysisk butikk",

      WHY_DOES_NOT_THE_CONCEPT_SUIT_YOU: "Hvorfor passer ikke konseptet deg?",
      THE_ORDER_DEADLINE_IS_TOO_EARLY:
        "Bestillingsfristen er for tidlig i uken",
      THE_NUMBER_PORTIONS_AVAILABLE_DOES_NOT_SUIT:
        "Antall porsjoner man kan velge passer ikke vår husholdning",

      WHAT_ABOUT_THE_MENUS_ARE_YOU_DISSATISFIED_WITH:
        "Hva med menyene er du misfornøyd med?",
      VARIETY_OF_INGREDIENTS_CONTENTS_IN_THE_DISHES:
        "Variasjon på ingredienser/innholdet i rettene",
      THE_SELECTED_COMBINATION_OF_DISHES:
        "Kombinasjonen av retter dere har valgt for meg",
      SELECTION_OF_DISH_TYPES: "Utvalg av type retter",
      THE_MENU_SUGGESTIONS_DO_NOT_MATCH_MY_SELECTED_PREFERENCES:
        "Menyforslagene passer ikke mine valgte preferanser",
      I_HAVE_TOO_MANY_INGREDIENTS_AT_HOME:
        "Jeg forventes å ha for mange ingredienser hjemme",
      UNNECESSARY_INGREDIENTS_I_ALREADY_HAVE_ARE_DELIVERED:
        "Dere leverer unødvendige ingredienser jeg allerede har",

      WHAT_ABOUT_THE_INGREDIENTS_ARE_YOU_DISSATISFIED_WITH:
        "Hva med ingrediensene er du misfornøyd med?",
      TOO_MUCH_PACKAGING: "For mye emballasje",
      EXPIRATION_DATE_AND_QUALITY_OF_INGREDIENTS:
        "Holdbarhetstid/kvalitet på ingrediensene",
      I_WANT_ORGANIC_INGREDIENTS: "Jeg ønsker økologiske ingredienser",
      BETTER_ANIMAL_WELFARE: "Bedre dyrevelferd",

      WHY_DID_YOU_DISLIKE_THE_CARTON_BOX: "Hva mislikte du ved kassen?",
      IT_IS_TOO_BIG_OR_DIFFICULT_TO_HANDLE: "For stor/vanskelig å håndtere",
      THE_WAY_THE_INGREDIENTS_ARE_ORGANIZED:
        "Måten ingrediensene er organisert",
      IT_LACKED_COOLING_ELEMENTS_IN_THE_BOX:
        "Det manglet kjøleelementer i kassen",
      I_WANT_THE_SERVICE_TO_RETURN_THE_BOX:
        "Jeg savner tjenesten å kunne returnere pappkassen",

      WHY_DO_YOU_WANT_TO_PAUSE: "Hvorfor vil du pause?",
      I_JUST_WANT_TO_TAKE_A_BREAK: "Jeg vil bare ta en pause",
      I_HAVE_A_LIMITED_BUDGET_AT_THE_MOMENT:
        "Jeg har begrenset budsjett for øyeblikket",
      I_AM_GOING_ON_VACATION: "Jeg skal på ferie/ut og reise",
      I_HAVE_A_BUSY_PERIOD_AHEAD: "Jeg har en travel periode framover",

      PRICE_IS_TOO_HIGH: "Prisen er for høy",
      THE_MEALBOX_IS_TOO_EXPENSIVE: "Matkassen er for dyr",
      TOO_MANY_DISHES_COST_EXTRA: "For mange retter koster ekstra",

      THE_MEALBOX_DOES_NOT_SUIT_US: "Passer ikke oss",
      THE_CONCEPT_DOES_NOT_SUIT_US: "Konseptet passer oss ikke",
      WE_WANT_TO_COOK_OUR_OWN_FOOD: "Vi vil lage vår egen mat",
      TOO_LITTLE_FOOD_FOR_OUR_FAMILY: "For lite mat for vår familie",
      TOO_MUCH_FOOD_FOR_OUR_FAMILY: "For mye mat for vår familie",
      WE_DO_NOT_HAVE_ENOUGH_TIME_IN_OUR_DAILY_LIFE:
        "Vi har ikke nok tid i hverdagen",

      INGREDIENT_OR_MENU: "Ingrediens eller meny",
      NOT_SATISFIED_WITH_THE_MENUS: "Ikke fornøyd med menyene",
      QUALITY_OF_THE_INGREDIENTS: "Kvalitet på ingrediensene",
      NEITHER_WE_NOR_THE_KIDS_LIKE_THE_FOOD:
        "Hverken vi eller barna liker maten",
      WE_HAVE_ALLERGIES_IN_THE_FAMILY: "Vi har allergier i familien",
      TOO_ADVANCED_OR_TAKES_TOO_LONG: "For avansert/tar for lang tid",
      MISSING_INGREDIENTS: "Manglende ingredienser",

      TRANSPORT_OR_DELIVERY: "Transport eller levering",
      DID_NOT_LIKE_THE_BOX_ITSELF: "Likte ikke selve kassen",
      DID_NOT_DELIVER_AS_AGREED: "Leverte ikke som avtalt",
      DELIVERY_TIMES_DID_NOT_SUIT_ME: "Leveringstidene passet meg ikke",
      COULD_NOT_DELIVER_TO_MY_ADDRESS: "Kunne ikke levere til min adresse",
      DELIVERY_FEE: "Leveringsavgift",
    },
    se: {
      SUGGESTIONS_TO_IMPROVE: "Har du andra förslag på vad vi kan göra bättre?",
      SUGGESTIONS_TO_IMPROVE_DESCRIPTION: "Vi vill gärna höra från dig!",
      OPTIONAL: "Frivilligt",
      GO_FORWARD: "Gå vidare",
      CANCEL: "Avbryt",
      PAUSE_SUBSCRIPTION: "Avsluta prenumeration",
      ADD_COMMENT: "Lägg till en kommentar",
      SUBSCRIPTION_IS_PAUSED: "Prenumeration är avslutad!",
      CAN_NOT_CHANGE_SUBSCRIPTION_STATUS:
        "Det gick inte att ändra din prenumeration.",
      CHOOSE_ONE_OF_THE_OPTIONS_BELOW: "Välj ett av alternativen nedan.",

      WHERE_WILL_YOU_BUY_FOOD_IN_THE_FUTURE:
        "Hur planerar du att handla din mat framöver?",
      ANOTHER_ONLINE_GROCERY_STORE: "Annan mataffär online",
      ANOTHER_ONLINE_MEALBOX_SERVICE: "Annan matkassetjänst online",
      PHYSICAL_STORE: "Fysisk dagligvarebutik",

      WHY_DOES_NOT_THE_CONCEPT_SUIT_YOU: "Varför passar inte konceptet er?",
      THE_ORDER_DEADLINE_IS_TOO_EARLY:
        "Sista dag för beställning inträffar för tidigt i veckan",
      THE_NUMBER_PORTIONS_AVAILABLE_DOES_NOT_SUIT:
        "Inget av alternativen för antal portioner passar vår familj",

      WHAT_ABOUT_THE_MENUS_ARE_YOU_DISSATISFIED_WITH:
        "Vad på menyerna är du missnöjd med?",
      VARIETY_OF_INGREDIENTS_CONTENTS_IN_THE_DISHES:
        "Variation i ingredienser/innehåll i rätterna",
      THE_SELECTED_COMBINATION_OF_DISHES:
        "Kombination av rätter som ni valt åt mig",
      SELECTION_OF_DISH_TYPES: "Typ av rätter som erbjuds",
      THE_MENU_SUGGESTIONS_DO_NOT_MATCH_MY_SELECTED_PREFERENCES:
        "Menyförslagen matchar inte mina preferenser",
      I_HAVE_TOO_MANY_INGREDIENTS_AT_HOME:
        "Jag förväntas ha för många ingredienser hemma",
      UNNECESSARY_INGREDIENTS_I_ALREADY_HAVE_ARE_DELIVERED:
        "Ni levererar onödiga ingredienser som jag redan har hemma",

      WHAT_ABOUT_THE_INGREDIENTS_ARE_YOU_DISSATISFIED_WITH:
        "Vad med ingredienserna är du missnöjd med?",
      TOO_MUCH_PACKAGING: "För mycket förpackning",
      EXPIRATION_DATE_AND_QUALITY_OF_INGREDIENTS:
        "Hållbarhet/kvalitet på ingredienserna",
      I_WANT_ORGANIC_INGREDIENTS: "Vill ha ekologiska ingredienser",
      BETTER_ANIMAL_WELFARE: "Bättre djurvälfärd",

      WHY_DID_YOU_DISLIKE_THE_CARTON_BOX:
        "Vad med matkassen tyckte du inte om?",
      IT_IS_TOO_BIG_OR_DIFFICULT_TO_HANDLE: "För stor/svår att hantera",
      THE_WAY_THE_INGREDIENTS_ARE_ORGANIZED:
        "Hur ingredienserna är organiserade",
      IT_LACKED_COOLING_ELEMENTS_IN_THE_BOX:
        "Det fanns inga kylelement i min leverans",
      I_WANT_THE_SERVICE_TO_RETURN_THE_BOX:
        "Jag saknar tjänsten där jag kunde returnera lådan",

      WHY_DO_YOU_WANT_TO_PAUSE: "Varför vill du pausa?",
      I_JUST_WANT_TO_TAKE_A_BREAK: "Jag vill bara ta en paus",
      I_HAVE_A_LIMITED_BUDGET_AT_THE_MOMENT: "Jag har begränsad budget just nu",
      I_AM_GOING_ON_VACATION: "Jag ska åka på semester/ut och resa",
      I_HAVE_A_BUSY_PERIOD_AHEAD: "Jag har en intensiv period framöver",

      PRICE_IS_TOO_HIGH: "Priset är för högt",
      THE_MEALBOX_IS_TOO_EXPENSIVE: "Matkassen är för dyr",
      TOO_MANY_DISHES_COST_EXTRA: "För många rätter kostar extra",

      THE_MEALBOX_DOES_NOT_SUIT_US: "Passar oss inte",
      THE_CONCEPT_DOES_NOT_SUIT_US: "Konceptet passar oss inte",
      WE_WANT_TO_COOK_OUR_OWN_FOOD: "Vi vill laga vår egen mat",
      TOO_LITTLE_FOOD_FOR_OUR_FAMILY: "För lite mat för vår familj",
      TOO_MUCH_FOOD_FOR_OUR_FAMILY: "För mycket mat för vår familj",
      WE_DO_NOT_HAVE_ENOUGH_TIME_IN_OUR_DAILY_LIFE:
        "Vi har inte tillräckligt med tid i vardagen",

      INGREDIENT_OR_MENU: "Ingrediens eller meny",
      NOT_SATISFIED_WITH_THE_MENUS: "Inte nöjd med menyerna",
      QUALITY_OF_THE_INGREDIENTS: "Kvaliteten på ingredienserna",
      NEITHER_WE_NOR_THE_KIDS_LIKE_THE_FOOD:
        "Varken vi eller barnen gillar maten",
      WE_HAVE_ALLERGIES_IN_THE_FAMILY: "Vi har allergier i familjen",
      TOO_ADVANCED_OR_TAKES_TOO_LONG: "För avancerat/tar för lång tid",
      MISSING_INGREDIENTS: "Saknade ingredienser",

      TRANSPORT_OR_DELIVERY: "Transport eller leverans",
      DID_NOT_LIKE_THE_BOX_ITSELF: "Gillade inte själva lådan",
      DID_NOT_DELIVER_AS_AGREED: "Levererade inte som utlovat",
      DELIVERY_TIMES_DID_NOT_SUIT_ME: "Leveranstiderna passade mig inte",
      COULD_NOT_DELIVER_TO_MY_ADDRESS: "Kunde inte leverera till min adress",
      DELIVERY_FEE: "Fraktavgiften",
    },
    dk: {
      SUGGESTIONS_TO_IMPROVE:
        "Har du noget, forslag til, hvad vi kan gøre bedre?",
      SUGGESTIONS_TO_IMPROVE_DESCRIPTION: "Vi vil gerne høre fra dig!",
      OPTIONAL: "Valgfrit",
      GO_FORWARD: "Fortsæt",
      CANCEL: "Annuller",
      PAUSE_SUBSCRIPTION: "Opsig abonnement",
      ADD_COMMENT: "Hvad kan vi gøre bedre?",
      SUBSCRIPTION_IS_PAUSED: "Abonnement opsagt.",
      CAN_NOT_CHANGE_SUBSCRIPTION_STATUS: "Kunne ikke ændre abonnementsstatus.",
      CHOOSE_ONE_OF_THE_OPTIONS_BELOW: "Vælg én af nedenstående muligheder.",
      WHERE_WILL_YOU_BUY_FOOD_IN_THE_FUTURE:
        "Hvor vil du handle ind til aftensmaden fremover?",
      ANOTHER_ONLINE_GROCERY_STORE: "Online dagligvarebutik",
      ANOTHER_ONLINE_MEALBOX_SERVICE: "Anden online måltidskasseleverandør",
      PHYSICAL_STORE: "Fysisk dagligvarebutik",
      WHY_DOES_NOT_THE_CONCEPT_SUIT_YOU:
        "Hvorfor passer konceptet ikke til dig?",
      THE_ORDER_DEADLINE_IS_TOO_EARLY: "Bestillingsfrist er for tidlig",
      THE_NUMBER_PORTIONS_AVAILABLE_DOES_NOT_SUIT:
        "Antallet af portioner man kan vælge passer ikke til vores husstand",
      WHAT_ABOUT_THE_MENUS_ARE_YOU_DISSATISFIED_WITH:
        "Hvad ved menuen er du utlifreds med?",
      VARIETY_OF_INGREDIENTS_CONTENTS_IN_THE_DISHES:
        "Variation i ingredienser/indholdet i retterne",
      THE_SELECTED_COMBINATION_OF_DISHES:
        "Jeg er utilfreds med den kombination af retter, I har valgt til mig",
      SELECTION_OF_DISH_TYPES: "Udvalget af type retter",
      THE_MENU_SUGGESTIONS_DO_NOT_MATCH_MY_SELECTED_PREFERENCES:
        "Menuforslagene matcher ikke mine valgte madpræferencer",
      I_HAVE_TOO_MANY_INGREDIENTS_AT_HOME:
        "Jeg forventes at have for mange ingredienser derhjemme",
      UNNECESSARY_INGREDIENTS_I_ALREADY_HAVE_ARE_DELIVERED:
        "I leverer unødvendige ingredienser, jeg allerede har derhjemme",
      WHAT_ABOUT_THE_INGREDIENTS_ARE_YOU_DISSATISFIED_WITH:
        "Hvad ved ingredienserne er du utilfreds med?",
      TOO_MUCH_PACKAGING: "For meget emballage",
      EXPIRATION_DATE_AND_QUALITY_OF_INGREDIENTS:
        "Holbarhed/kvalitet af ingredienser",
      I_WANT_ORGANIC_INGREDIENTS: "Ønsker økologiske ingredienser",
      BETTER_ANIMAL_WELFARE: "Bedre dyrevelfærd",
      WHY_DID_YOU_DISLIKE_THE_CARTON_BOX: "Hvad kunne du ikke lide ved kassen?",
      IT_IS_TOO_BIG_OR_DIFFICULT_TO_HANDLE: "For stor/udfordrende at håndtere",
      THE_WAY_THE_INGREDIENTS_ARE_ORGANIZED:
        "Måden ingredienserne er organiseret på",
      IT_LACKED_COOLING_ELEMENTS_IN_THE_BOX:
        "Der var ingen køleelementer i min kasse",
      I_WANT_THE_SERVICE_TO_RETURN_THE_BOX:
        "Jeg savner den service, hvor jeg kunne sende papkassen retur",

      WHY_DO_YOU_WANT_TO_PAUSE:
        "Hvorfor vil du gerne sætte dit abonnement på pause?",
      I_JUST_WANT_TO_TAKE_A_BREAK: "Vil gerne have en pause",
      I_HAVE_A_LIMITED_BUDGET_AT_THE_MOMENT: "Begrænset budget i øjeblikket",
      I_AM_GOING_ON_VACATION: "Jeg skal på ferie/ud at rejse",
      I_HAVE_A_BUSY_PERIOD_AHEAD: "Travl periode forude",

      PRICE_IS_TOO_HIGH: "Prisen er for høj",
      THE_MEALBOX_IS_TOO_EXPENSIVE: "Matkassen er for dyr",
      TOO_MANY_DISHES_COST_EXTRA: "For mange retter koster ekstra",

      THE_MEALBOX_DOES_NOT_SUIT_US: "Ikke noget for oss",
      THE_CONCEPT_DOES_NOT_SUIT_US: "Konceptet er ikke noget for os",
      WE_WANT_TO_COOK_OUR_OWN_FOOD: "Vi vil gerne lave vores egen mad",
      TOO_LITTLE_FOOD_FOR_OUR_FAMILY: "For lidt mad til vores familie",
      TOO_MUCH_FOOD_FOR_OUR_FAMILY: "For meget mad til vores familie",
      WE_DO_NOT_HAVE_ENOUGH_TIME_IN_OUR_DAILY_LIFE: "Ikke nok tid i hverdagen",

      INGREDIENT_OR_MENU: "Ingredienser eller menu",
      NOT_SATISFIED_WITH_THE_MENUS: "Ikke tilfreds med ugemenuen",
      QUALITY_OF_THE_INGREDIENTS: "Ingredienserne kvalitet",
      NEITHER_WE_NOR_THE_KIDS_LIKE_THE_FOOD:
        "Hverken vi eller børnene kan lide maden",
      WE_HAVE_ALLERGIES_IN_THE_FAMILY: "Vi har fødevareallergier i familien",
      TOO_ADVANCED_OR_TAKES_TOO_LONG: "For kompliceret/tager for lang tid",
      MISSING_INGREDIENTS: "Manglende ingredienser",

      TRANSPORT_OR_DELIVERY: "Transport eller levering",
      DID_NOT_LIKE_THE_BOX_ITSELF: "Kunne ikke lide selve kassen",
      DID_NOT_DELIVER_AS_AGREED: "Leverede ikke som aftalt",
      DELIVERY_TIMES_DID_NOT_SUIT_ME: "Leveringstider passende ikke mig",
      COULD_NOT_DELIVER_TO_MY_ADDRESS: "Kunne ikke levere til min adresse",
      DELIVERY_FEE: "Leveringsgebyr",
    },
  } as const
)[language];
